
//会员等级，会员设置页面接口
import { get, post, postJson, postBlob, postJsonBlob} from '../axios2'
const RESOURCE_BASE_PATH = '/PointActivityAnalyticController';

const RESOURCE_BASE_PATH2 = '/PointActivityEffectDetails';


/***
 * 数据分析-奖品统计-导出表格数据
 * /PointActivityAnalyticController/exportTablePrizeStates
 */
export const getExportTablePrizeStates = p => postJsonBlob(`/jd-hd-web${RESOURCE_BASE_PATH}/exportTablePrizeStates`, p)

/***
 * 数据分析-活动数据-折线图
 * @param p/
 */
export const getChartEffectDetails = p => get(`${RESOURCE_BASE_PATH}/getChartEffectDetails`, p)

/***
 * 数据分析-奖品统计-折线图
 * 
 */
export const getChartPrizeStates = p => get(`${RESOURCE_BASE_PATH}/getChartPrizeStates`, p)


/***
 * 数据分析-活动数据-折线图
 * @param p/
 */
export const getGoodRecords = p => get(`${RESOURCE_BASE_PATH2}/goodRecords`, p)

/***
 * 积分中心-积分商城-兑换记录
 * @param p/
 */
export const getExchangeActivityRecord = p => postJson(`${RESOURCE_BASE_PATH}/getExchangeActivityRecord`, p)


/***
 * 数据分析-活动数据-数据总览
 * @param
 */
export const getSumEffectDetails = p => get(`${RESOURCE_BASE_PATH}/getSumEffectDetails`, p)

/***
 * 数据分析-奖品统计-表格数据
 * @param
 */
export const getTablePrizeStates = p => get(`${RESOURCE_BASE_PATH}/getTablePrizeStates`, p)

/***
 * 数据分析-积分任务-折线图数据
 * @param
 */
export const checkRecord = p => get(`${RESOURCE_BASE_PATH2}/getChartEffectChart`, p)

/***
 * 数据分析-积分任务-汇总数据
 * @param
 */
export const getCouponData = p => get(`${RESOURCE_BASE_PATH2}/getSumEffectDetails`, p)

/***
 * 数据分析-积分任务-列表数据
 * @param
 */
export const getCouponTable = p => get(`${RESOURCE_BASE_PATH2}/getTableEffectDetails`, p)

/***
 * 数据分析-积分任务-签到记录
 * @param
 */
export const checkList = p => get(`${RESOURCE_BASE_PATH2}/singleRecords`, p)

/***
 * 数据分析-积分任务-中奖记录
 * @param
 */
export const awardRecord = p => get(`${RESOURCE_BASE_PATH2}/pointActivityPrizeDetail`, p)

//中奖记录-邀请类
export const awardRecNew = p => get(`${RESOURCE_BASE_PATH2}/pointInviteActivityPrize`, p)

//中奖记录-邀请开卡单独抽离出来
export const awardRecNewOne = p => get(`${RESOURCE_BASE_PATH2}/pointInviteCardActivityPrize`, p)

//开卡记录----邀请统计 
export const invaidStatics = p => get(`${RESOURCE_BASE_PATH2}/pointInviteStatisticsList`, p)

//开卡记录-邀请统计-明细
export const invitationDetailNew = p => get(`${RESOURCE_BASE_PATH2}/pointInviteStatisticsDetail`, p)

// 开卡记录-被邀请人明细
export const getInviteDetail = p => get(`/invitePointActivity/inviteDetail`, p)

//导出
export const exportRecord = p => postJsonBlob(`/jd-hd-web${RESOURCE_BASE_PATH2}/exportPointActivityPrizeDetail`, p)

//导出-邀请类
export const exportRecNew = p => postJsonBlob(`/jd-hd-web${RESOURCE_BASE_PATH2}/exportPointInviteActivityPrize`, p)

/***
 * 数据分析-积分任务-实物名单
 * @param
 */
export const inKindList = p => get(`${RESOURCE_BASE_PATH2}/goodRecords`, p)

/***
 * 数据分析-积分任务-用户资料明细
 * @param
 */
export const improveList = p => get(`${RESOURCE_BASE_PATH2}/memberImproveRecords`, p)

/***
 * 数据分析-积分任务-标记状态
 * @param
 */
export const signIssuance = p => get(`${RESOURCE_BASE_PATH2}/markingSendStatus`, p)


/**
 * 数据分析-获取礼包活动下单转化数据
 * @parm
 */
// export const getShopGiftParticipateConver = p => get(`giftBag/getShopGiftParticipateConver`, p)
 
export const getShopGiftParticipateConver = p => get(`PointActivityEffectDetails/getSumEffectOrder`, p)


// 拼券明细
export const getSplitCouponlist = p => postJson(`/splitCoupon/coupon/page`, p)

// 优惠卷统计
export const getStatisticsCouponlist = p => postJson(`splitCoupon/coupon/statistics`, p)

// 团队详情
export const CouponDetail = p => postJson(`/splitCoupon/group/detail`, p)

// 组团明细
export const CouponDetailmember = p => get(`/splitCoupon/group/member/list/${p}`)

// 查询裂变神券
export const CouponDetailID = p => get(`/splitCoupon/${p}`)

// 抽奖机会赠送记录查询列表接口
export const commentDraw = p => get(`/comment/draw/page`, p)

// 抽奖机会赠送记录查询列表接口
export const participation = p => get(`/PointActivityAnalyticController/page/participation`, p)

// 参与赠送记录查询列表接口
export const gameTaskRecord = p => get(`/PointActivityAnalyticController/gameTaskRecord`, p)


// 实物导出验证码
export const getExportCode = p => get(`/seller/getSellerCheckCode`)

// 实物导出验证码
export const getExportxlxs = p => postBlob(`/jd-hd-web/PointActivityEffectDetails/exportGoodRecords`, p)

// 生日有礼活动统计导出
export const pointActivityEffectDetailsExport = p => postJsonBlob(`/jd-hd-web/PointActivityEffectDetails/export`, p)

// 锁权 导出验证码
export const getExportLockRight = p => postBlob(`/jd-hd-web/lockRightRecord/export`, p)
// 锁权-中奖记录 收货信息 导出验证码
export const getExportLockWin = p => postBlob(`/jd-hd-web/lockRight/winRecord/export`, p)

// 批量标记发货状态
export const markDeliveryStatus = p => postJson(`/PointActivityAnalyticController/markDeliveryStatus/batch`, p)

// 确权 发货
export const lockSendStatus = p => postJson(`/lockRight/markingSendStatus`, p)
// 
export const DeliveryStatus = (id,deliveryFlag) => postJson(`/PointActivityAnalyticController/markDeliveryStatus?id=${id}&deliveryFlag=${deliveryFlag}` )

export const markingSendStatus = (source,p) => postJson(`/PointActivityEffectDetails/markingSendStatus/batch?source=${source}`, p)

export const getActivityRuleFields = p => get(`/PointActivityEffectDetails/getActivityRuleFields/${p}`)

///jd-hd-web
export const getSumEffectDetailsV1 = p => get(`/PointActivityEffectDetails/getSumEffectDetailsV1`, p)

//
export const getChartEffectChartV1 = p => get(`/PointActivityEffectDetails/getChartEffectChartV1`, p)


// 数据汇总
export const getSmartDataSum = p => get(`/PointActivityEffectDetails/smartDataSum`, p)

// 数据明细
export const getSmartDataDetail = p => get(`/PointActivityEffectDetails/smartDataDetail`, p)

// getCouponTable

//拼券明细分页
export const splitCouponPage = p => get(`/super-splitCoupon/coupon/page`, p)

//团队详情
export const splitCouponGroup = p => postJson(`/super-splitCoupon/group/detail`, p)
//团队详情
export const groupMember = p => get(`/super-splitCoupon/group/member/list/${p}`)


//优惠券列表/
export const getCoupon = p => get(`/super-splitCoupon/coupon/${p}`)

//优惠券列表/
export const splitCouponStatistics = p => postJson(`/super-splitCoupon/coupon/statistics`, p)

//开卡记录/
export const openCardRecord = p => get(`/memberCard/openCardRecord`, p)
//预约记录/
export const appointment = p => postJson(`/freeTrial/appointment`, p)

// 加购记录
export const addCartpage = p => get(`/incentivesForAddCart/page`, p)
// 加购详情
export const addCartDetail = p => get(`/incentivesForAddCart/detail/`+ p)

// 锁权记录 lockRightRecord
export const lockRightRecord = p => get(`/lockRightRecord/page`, p)

// 中奖记录 积分锁权 lockRightRecord
export const lockWinRecord = p => get(`/lockRight/winRecord/page`, p)

// 修改发货信息 积分锁权-发货信息
export const updateReceiveAddress = p => postJson(`/lockRight/updateReceiveAddress`, p)


// 中奖记录列表添加地址信息接口-积分锁权
export const winRecordAddAddress = p => postJson(`/lockRight/winRecordAddAddress`, p)





//积分确权数据统计接口
export const getSumLockEffectJi = p => get(`/lockRightRecord/getSumLockEffect`, p)

//积分确权数据明细
export const getDetailLockEffectJi = p => get(`/lockRightRecord/getDetailLockEffect`, p)

//积分导出
export const exportJi = p => postBlob(`/jd-hd-web/lockRightRecord/statistics/export`, p)

// 发货接口（单个）
export const markingSendStatusLockRight = p => postJson(`/lockRight/markingSendStatus`, p)

// 打榜有礼数据总览
export const getDataOverview = p => get(`/order-rank/activityStatistic/dataOverview`, p)

// 打榜有礼数据明细
export const getDetailPage = p => get(`/order-rank/activityStatistic/detail/page`, p);

// 打榜有礼活动导出
export const getExport = p => postJsonBlob(`/jd-hd-web/order-rank/activityStatistic/export`, p);

// 打榜有礼实物导出
export const goodsRecordExport = p => postJsonBlob(`/jd-hd-web/order-rank/goodsRecord/export`, p);

// 打榜有礼领奖记录导出
export const winRecordExport = p => postJsonBlob(`/jd-hd-web/order-rank/winRecord/export`, p);

// 打榜有礼领奖记录
export const getWinRecordPage = p => get(`/order-rank/winRecord/page`, p);

// 下单有礼解锁记录
export const getUnlockRecord = p => get(`/PointActivityEffectDetails/pointActivityPrizeDetail`, p);

// 下单有礼解锁记录导出
export const exportCheckOrderDetail = p => postJsonBlob(`/jd-hd-web/PointActivityEffectDetails/exportCheckOrderDetail`, p);

// 积分中心-积分商城-导出兑换记录
export const exportExchangeActivityRecord = p => postJson(`/PointActivityAnalyticController/exportExchangeActivityRecord`, p);



// 打榜有礼实物奖品名单
export const getGoodsRecordPage = p => get(`/order-rank/goodsRecord/page`, p);

// 查询派样/回购下单商品列表接口
export const getOrderRecordPage = p => get(`/sendReBuy/orderRecordPage`, p);

//查询派样随单发
export const promoPage = p => postJson(`/promoSendReBuy/payOrder/page`, p);

//令牌查询
export const promoPageToken = p => postJson(`/promoSendReBuy/tokenRecord/page`, p);

//派样回购对标商品
export const benchmarking = p => postJson(`/promoSendReBuy/benchmarking/page`, p);

// 导出-派样/回购下单商品列表接口
export const orderRecordPageExport = p => postJsonBlob(`/jd-hd-web//sendReBuy/orderRecordPage/export`, p);

// 派样回购数据统计概况
export const getSumEffect = p => get(`/sendSampleRecord/getSumEffect`, p);

// 随单发
export const getSumEffectOne = p => get(`/promoSendReBuy/getSumEffect`, p);

// 派样回购数据统计详细
export const getDetailEffect = p => get(`/sendSampleRecord/getDetailEffect`, p);

// 随单发数据统计详细
export const getDetailEffectOne = p => get(`/promoSendReBuy/getDetailEffect`, p);



// 派样回购数据统计详细(含合计)
export const getDetailIncludeTotal = p => get(`/sendSampleRecord/getDetailIncludeTotal`, p);

// 随单发统计详情
export const getDetailIncludeTotalOne = p => get(`/promoSendReBuy/getSkuDetailEffect`, p);

// 派样回购数据统计导出
export const sendSampleRecordExport  = p => postJsonBlob(`/jd-hd-web/sendSampleRecord/export`, p);

// 随单发导出
export const sendSampleRecordExportOne  = p => postJsonBlob(`/jd-hd-web/promoSendReBuy/export`, p);

// 派样下单创建活动
export const saveActivity  = p => postJson(`/sendReBuy/saveActivity`, p);

// 派样下单详情
export const getSendReBuyDetail = p => get(`/sendReBuy/detail/${p}`)

// 获取随单发详情接口
export const promoReBuyDetail = p => get(`/promoSendReBuy/detail/${p}`)

// 互动/京获客生成京东/云起人群
export const generateCrowBySearch  = p => postJson(`/crowd-generate/generateCrowBySearch`, p);

// 录入快递单号
export const markingSendStatusForPointActivity = p => postJson(`/PointActivityAnalyticController/markingSendStatus`, p);

/***
 * 积分活动白名单分页接口
 * @param
 */
export const pointActivityWhite = p => get(`/pointActivityWhite/page`, p)

/***
 * 积分活动新增或更新白名单接口
 * @param
 */
export const pointActivityAddOrUpdate = p => postJson(`/pointActivityWhite/saveOrUpdateWhite`, p)

// 订单明细
export const orderDetailPage  = p => get(`/PointActivityEffectDetails/orderDetailPage`, p);

// 入会用户转化分析
export const memConvAnalysis  = p => postJson(`/PointActivityEffectDetails/memConvAnalysis`, p);

// 数据分析-中奖记录-奖品发放总览
export const prizeSum = p => get(`/PointActivityEffectDetails/prizeSum`, p)

// 数据分析-导出订单购买行为中奖记录
export const exportPointActivityPrizeDetailForPurchase = p => postJsonBlob(`/jd-hd-web/PointActivityEffectDetails/exportPointActivityPrizeDetailForPurchase`, p);

// 数据分析-邀请开卡-导出邀请开卡中奖记录
export const exportPointInviteCardActivityPrize = p => postJsonBlob(`/jd-hd-web/PointActivityEffectDetails/exportPointInviteCardActivityPrize`, p);

// 领取记录
export const exportPointActivityPrizeDetail = p => postJsonBlob(`/jd-hd-web/PointActivityEffectDetails/exportPointActivityPrizeDetail`, p);

// 查询活动奖项
export const getPrizeNames = p => get('/paradiseAndTaskCommon/activity/prize',p)

//随单发
export const promoSave = p => postJson('/promoSendReBuy/saveActivity',p)

//修改活动通用接口
export const paradise = p => postJson('/paradiseAndTaskCommon/activity/update',p)

//手动发放令牌
export const promoSendReBuyToken = p => postJson('/promoSendReBuy/token/send',p)

//重新发放令牌
export const reToken = p => get('/promoSendReBuy/token/reSend',p)

// 核销令牌
export const promoToken = p => postJson('/promoToken/useToken', p)